import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const QuickViewArticle = lazy(
  () =>
    import('./QuickViewArticle.eager').then(mod => ({
      default: mod.QuickViewArticle,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
